import { render, staticRenderFns } from "./MedicalCertificateResponse.vue?vue&type=template&id=12c042ea&scoped=true"
import script from "./MedicalCertificateResponse.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificateResponse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c042ea",
  null
  
)

export default component.exports